import apiClient, { ApiResponse, PaginatedResponse } from '../api/client';
import { Notification } from '../types/models';

export interface NotificationFilters {
  is_read?: boolean;
  type?: string;
  page?: number;
  per_page?: number;
}

class NotificationService {
  private baseUrl = '/admin/county/notifications';

  async getNotifications(filters?: NotificationFilters): Promise<ApiResponse<PaginatedResponse<Notification>>> {
    const params = new URLSearchParams();
    if (filters?.is_read !== undefined) params.append('is_read', filters.is_read.toString());
    if (filters?.type) params.append('type', filters.type);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.per_page) params.append('per_page', filters.per_page.toString());

    return apiClient.get<PaginatedResponse<Notification>>(`${this.baseUrl}?${params.toString()}`);
  }

  async getUnreadNotifications(): Promise<ApiResponse<Notification[]>> {
    return apiClient.get<Notification[]>(`${this.baseUrl}/unread`);
  }

  async getNotification(id: string): Promise<ApiResponse<Notification>> {
    return apiClient.get<Notification>(`${this.baseUrl}/${id}`);
  }

  async markAsRead(id: string): Promise<ApiResponse<Notification>> {
    return apiClient.post<Notification>(`${this.baseUrl}/${id}/mark-as-read`);
  }

  async markAllAsRead(): Promise<ApiResponse> {
    return apiClient.post(`${this.baseUrl}/mark-all-as-read`);
  }

  async deleteNotification(id: string): Promise<ApiResponse> {
    return apiClient.delete(`${this.baseUrl}/${id}`);
  }

  async deleteAllRead(): Promise<ApiResponse> {
    return apiClient.delete(`${this.baseUrl}/delete-all-read`);
  }

  async getUnreadCount(): Promise<ApiResponse<{ count: number }>> {
    return apiClient.get<{ count: number }>(`${this.baseUrl}/unread-count`);
  }
}

export const notificationService = new NotificationService();
export default notificationService;
